import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";

const TextAreaComponent = ({height = "220px", onchange, error, placeholder, textlabel,isError, value, isRequired, style = {}, autoGrow = false, autoFocus = false, focusAtEnd = false, maxLength }) => {
  const textareaRef = useRef(null);

  const resizeToContent = () => {
    if (autoGrow && textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    resizeToContent();
  }, [value, autoGrow]);

  const handleFocus = (event) => {
    if (focusAtEnd) {
      const cursorPosition = event.target.value.length;
      event.target.setSelectionRange(cursorPosition, cursorPosition);
    }
  };

return(<Box  style={{padding:10}}>
    <p style={{padding:0, margin:0, marginBottom:10, color:"#4E657C", fontSize:19, fontWeight:700}}>{textlabel}
        {isRequired && (
          <span style={{ color: "#f44336", marginLeft: 2 }}>*</span>
        )}
      </p>
    <textarea
      ref={textareaRef}
      className="form-control"
      style={{height: autoGrow ? "auto" : height, minHeight: autoGrow ? height : undefined, overflow: autoGrow ? "hidden" : undefined, resize: "none", width: "100%", ...style}}
      placeholder={placeholder}
      onChange={(event) => {
        resizeToContent();
        onchange?.(event);
      }}
      onFocus={handleFocus}
      value={value}
      maxLength={maxLength}
      autoFocus={autoFocus}
    />
    {isError ? <p className="input-error-text">{error}</p> : null}
</Box>);
}

export default TextAreaComponent;